var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "view-field", attrs: { column: "", "align-start": "" } },
    [
      _c(
        "v-layout",
        {
          staticClass: "title-section",
          attrs: { row: "", "align-center": "" }
        },
        [
          _c(
            "v-icon",
            {
              staticStyle: { "margin-right": "15px" },
              attrs: { color: "accent", left: "", size: "18" }
            },
            [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")]
          ),
          _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _vm.data === null || _vm.data === undefined
        ? _c("div", { staticClass: "data" }, [_vm._v("\n    -\n  ")])
        : typeof _vm.data === "number" || typeof _vm.data === "string"
        ? _c("div", { staticClass: "data" }, [
            _vm._v("\n    " + _vm._s(_vm.data) + "\n  ")
          ])
        : _vm._l(_vm.data, function(item) {
            return _c("div", { key: item, staticClass: "data" }, [
              _vm._v("\n    " + _vm._s(item) + "\n  ")
            ])
          }),
      _vm._v(" "),
      !_vm.hasPermission
        ? _c("app-no-permission-warning", {
            staticStyle: { padding: "0 0 0 35px" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-045e834d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045e834d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/ViewPage/ViewPageDataField.vue
// module id = null
// module chunks = 